import OrganizationDSP from '@/common/models/misc-api-models/OrganizationDSP';
import { QueryParams } from '@/common/models/query-params';
import ErrorHandler from '@/ErrorHandler';
import ExchangeAppAPIProxy from '@/exch-app/api';
import OrgAppAPIProxy from '@/org-app/api';
import { queryKeys } from '@/org-app/services/tanstack/queryKeys';
import { createGetQuery, isCuratorOrExchange } from '@/org-app/services/tanstack/queryUtils';
import orgAppStore from '@/org-app/store';
import { UPDATE_ORGANIZATION_DSPS_LIST } from '@/org-app/store/modules/referenceData/mutation-types';
import i18n from '@/vueI18n';

export const useOrganizationDSPs = createGetQuery<OrganizationDSP>(
  [queryKeys.organizationDSPs],
  (queryParams: QueryParams) =>
    isCuratorOrExchange()
      ? ExchangeAppAPIProxy.instance.getOrganizationDSPs({ queryParams })
      : OrgAppAPIProxy.instance.getOrganizationDSPs({ queryParams }),
  {
    mutation: (data: OrganizationDSP[]) => {
      orgAppStore.modules.ReferenceData.mutations[UPDATE_ORGANIZATION_DSPS_LIST](
        orgAppStore.modules.ReferenceData.state,
        data,
      );
    },
    onError(error) {
      const msg = i18n.global.t('messages.failedToGetBuyers');
      ErrorHandler.showError(msg, error);
    },
  },
);
